import { format } from 'date-fns';
import { memo } from 'react';
import { useSelector } from 'react-redux';

import { ClockIcon } from '@air/design-icons';
import { MONTH_DAY_YEAR_FORMAT, parseAirDateToISO } from '@air/utilities';

import { InfoPanelDetailsSection } from '~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailsSection';
import { InfoPanelDetailValue } from '~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailValue';
import { centralizedClipUpdatedAtSelector } from '~/store/centralizedClip/selectors';

export const InfoPanelDateModified = memo(() => {
  const updatedAt = useSelector(centralizedClipUpdatedAtSelector);
  const formattedUpdatedAt = format(parseAirDateToISO(updatedAt), MONTH_DAY_YEAR_FORMAT);

  return (
    <InfoPanelDetailsSection Icon={ClockIcon} title="Last Modified">
      <InfoPanelDetailValue value={formattedUpdatedAt} additionalInfo="Last modified" />
    </InfoPanelDetailsSection>
  );
});

InfoPanelDateModified.displayName = 'InfoPanelDateModified';
